import axios from "@/libs/api.request";

export const findUserConfig = () => {
  return axios.request({
    url: 'api/userConfig/find',
    method: 'get'
  })
};

export const saveUserConfig = (form) => {
  const data = {...form}
  return axios.request({
    url: 'api/userConfig/save',
    method:'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/userSetting.js